// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* default styling *


* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  
  ul {
    list-style: none;
  }
  
  a {
    text-decoration: none;
    color: black;
    font-size: 18px;
  }
  
  /* navbar */

.Navbar_a__1orF4 {
  color: #f3c05b;
}

.Navbar_navbar__fqjml {
  /* background-color: aliceblue; */
  background-color: #282c34;

  font-family: "Outfit";
  padding: 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  min-height: 10px;
  /* min-width: 40vw; */
}

a {
  color: #f3c05b;
  text-decoration: none;
}

/* logo  */
.Navbar_logo__9jxnA {
  font-size: 30px;
  font-family: asap, Arial, Helvetica, sans-serif;
}

/* ul  */
.Navbar_navMenu__6355t {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 100px;
  list-style-type: none;
}

/* media queries */

@media screen and (max-width: 780px) {
  /* hamburger */
  .Navbar_hamburger__lJxJG {
    display: block;
    cursor: pointer;
  }

  .Navbar_bar__n9VWW {
    /* background-color: #120f0b; */
    background-color: #f3c05b;
    width: 20px;
    height: 3px;
    display: block;
    margin: 5px;
    transition: 0.3s ease-in-out;
  }

  /* adding active class to the bars  */
  .Navbar_hamburger__lJxJG.Navbar_active__dp0nX .Navbar_bar__n9VWW:nth-child(2) {
    opacity: 0;
  }
  .Navbar_hamburger__lJxJG.Navbar_active__dp0nX .Navbar_bar__n9VWW:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
  }
  .Navbar_hamburger__lJxJG.Navbar_active__dp0nX .Navbar_bar__n9VWW:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
  }

  /* navMenu */

  .Navbar_navMenu__6355t {
    position: absolute;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0;
    top: 70px;
    left: -100%;
    text-align: start;
    width: 100%;
    height: 100%;
    transition: 0.7s ease-in-out;
    background-color: #282c34;
    padding: 10px;
  }

  .Navbar_navMenu__6355t.Navbar_active__dp0nX {
    left: 0;
  }

  .Navbar_navMenu__6355t li {
    margin: 16px 0;
    list-style-type: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Navbar.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;aAmBa;;AAEb;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;;EAEzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,+CAA+C;AACjD;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,qBAAqB;AACvB;;AAEA,kBAAkB;;AAElB;EACE,cAAc;EACd;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,+BAA+B;IAC/B,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,cAAc;IACd,WAAW;IAEX,4BAA4B;EAC9B;;EAEA,qCAAqC;EACrC;IACE,UAAU;EACZ;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;;EAEA,YAAY;;EAEZ;IACE,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,MAAM;IACN,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;AACF","sourcesContent":["/* default styling *\n\n\n* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n  }\n  \n  ul {\n    list-style: none;\n  }\n  \n  a {\n    text-decoration: none;\n    color: black;\n    font-size: 18px;\n  }\n  \n  /* navbar */\n\n.a {\n  color: #f3c05b;\n}\n\n.navbar {\n  /* background-color: aliceblue; */\n  background-color: #282c34;\n\n  font-family: \"Outfit\";\n  padding: 20px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  min-height: 10px;\n  /* min-width: 40vw; */\n}\n\na {\n  color: #f3c05b;\n  text-decoration: none;\n}\n\n/* logo  */\n.logo {\n  font-size: 30px;\n  font-family: asap, Arial, Helvetica, sans-serif;\n}\n\n/* ul  */\n.navMenu {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 100px;\n  list-style-type: none;\n}\n\n/* media queries */\n\n@media screen and (max-width: 780px) {\n  /* hamburger */\n  .hamburger {\n    display: block;\n    cursor: pointer;\n  }\n\n  .bar {\n    /* background-color: #120f0b; */\n    background-color: #f3c05b;\n    width: 20px;\n    height: 3px;\n    display: block;\n    margin: 5px;\n    -webkit-transition: 0.3s ease-in-out;\n    transition: 0.3s ease-in-out;\n  }\n\n  /* adding active class to the bars  */\n  .hamburger.active .bar:nth-child(2) {\n    opacity: 0;\n  }\n  .hamburger.active .bar:nth-child(1) {\n    transform: translateY(8px) rotate(45deg);\n  }\n  .hamburger.active .bar:nth-child(3) {\n    transform: translateY(-8px) rotate(-45deg);\n  }\n\n  /* navMenu */\n\n  .navMenu {\n    position: absolute;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 0;\n    top: 70px;\n    left: -100%;\n    text-align: start;\n    width: 100%;\n    height: 100%;\n    transition: 0.7s ease-in-out;\n    background-color: #282c34;\n    padding: 10px;\n  }\n\n  .navMenu.active {\n    left: 0;\n  }\n\n  .navMenu li {\n    margin: 16px 0;\n    list-style-type: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": `Navbar_a__1orF4`,
	"navbar": `Navbar_navbar__fqjml`,
	"logo": `Navbar_logo__9jxnA`,
	"navMenu": `Navbar_navMenu__6355t`,
	"hamburger": `Navbar_hamburger__lJxJG`,
	"bar": `Navbar_bar__n9VWW`,
	"active": `Navbar_active__dp0nX`
};
export default ___CSS_LOADER_EXPORT___;
